import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProductDetails from "../customer/Components/Product/ProductDetails/ProductDetails";
import Product from "../customer/Components/Product/Product/Product";
import Contact from "../Pages/Contact";
import TearmsCondition from "../Pages/TearmsCondition";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import About from "../Pages/About";
import Homepage from "../Pages/Homepage";
import Navigation from "../customer/Components/Navbar/Navigation";
import Cart from "../customer/Components/Cart/Cart";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button } from "@mui/material";
import { customTheme, customerTheme } from "../Admin/them/customeThem";
import Order from "../customer/Components/orders/Order";
import OrderDetails from "../customer/Components/orders/OrderDetails";
import Checkout from "../customer/Components/Checkout/Checkout";
import Footer from "../customer/Components/footer/Footer";
import PaymentSuccess from "../customer/Components/paymentSuccess/PaymentSuccess";
import RateProduct from "../customer/Components/ReviewProduct/RateProduct";
import SearchProduct from "../customer/Components/Product/Product/SearchProduct";
import ChangePassword from "../customer/Components/Profile/ChangePassword";
import AuthModal from "../customer/Components/Auth/AuthModal";

const CustomerRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { auth } = useSelector((store) => store);
  const jwt = localStorage.getItem("jwt");

  // Check if user is authenticated
  const isAuthenticated = !!jwt && !!auth.user;

  // Auth modal state - NO LONGER opens by default
  // Guests can now browse freely without authentication
  const [openAuthModal, setOpenAuthModal] = useState(false);

  // Open modal when navigating to /login or /register routes OR if query param has login=true
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (location.pathname === "/login" || location.pathname === "/register" || searchParams.get("login") === "true") {
      setOpenAuthModal(true);
    }
  }, [location.pathname, location.search]);

  // Close modal when user is authenticated
  useEffect(() => {
    if (auth.user) {
      setOpenAuthModal(false);
    }
  }, [auth.user]);

  const handleOpenAuthModal = () => {
    setOpenAuthModal(true);
  };

  const handleCloseAuthModal = () => {
    // Allow closing modal - guests can browse freely
    setOpenAuthModal(false);

    // If we are on /login or /register, navigate away to avoid inconsistent state
    if (location.pathname === "/login" || location.pathname === "/register") {
      navigate("/");
    } else {
      // If we used the ?login=true parameter, clear it so it can be triggered again
      const searchParams = new URLSearchParams(location.search);
      if (searchParams.get("login") === "true") {
        searchParams.delete("login");
        const query = searchParams.toString();
        navigate({
          pathname: location.pathname,
          search: query ? `?${query}` : ""
        }, { replace: true });
      }
    }
  };

  // Only show Navigation component when not on the NotFound page
  const showNavigation = location.pathname !== "*";

  // Akhil comments - path variable commented out
  // const path=["/","/home","/about","/privacy-policy","/terms-condition","/contact","/men",`/product/${productId}`]
  return (
    <div>

      <ThemeProvider theme={customerTheme}>
        {/* Content wrapper with flexbox to ensure footer stays at bottom */}
        <div className="flex flex-col min-h-screen">
          {showNavigation && <Navigation onOpenAuthModal={handleOpenAuthModal} />}
          {/* Main content wrapper - expands to fill space */}
          <div className={`flex-grow ${location.pathname === '/' || location.pathname === '/home' || location.pathname === '/login' || location.pathname === '/register' || location.pathname === '/about' || location.pathname === '/contact' || location.pathname === '/privacy-policy' || location.pathname === '/privaciy-policy' || location.pathname === '/terms-condition' ? '' : 'pt-4'}`}>
            <Routes>
              <Route path="/login" element={<Homepage />}></Route>
              <Route path="/register" element={<Homepage />}></Route>

              <Route path="/" element={<Homepage />}></Route>
              <Route path="/products/search" element={<SearchProduct />}></Route>
              <Route path="/home" element={<Homepage />}></Route>
              <Route path="/about" element={<About />}></Route>
              <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route>
              <Route path="/privaciy-policy" element={<PrivacyPolicy />}></Route>
              <Route path="/terms-condition" element={<TearmsCondition />}></Route>
              <Route path="/contact" element={<Contact />}></Route>
              <Route path="/:lavelOne/:lavelTwo/:lavelThree" element={<Product />}></Route>
              <Route path="/:lavelOne/:lavelTwo" element={<Product />}></Route>
              <Route path="/:lavelOne" element={<Product />}></Route>
              <Route path="/product/:productId" element={<ProductDetails />}></Route>
              <Route path="/cart" element={<Cart />}></Route>
              <Route path="/account/order" element={<Order />}></Route>
              <Route path="/account/order/:orderId" element={<OrderDetails />}></Route>
              <Route path="/account/rate/:productId" element={<RateProduct />}></Route>
              <Route path="/account/change-password" element={<ChangePassword />}></Route>
              <Route path="/checkout" element={<Checkout />}></Route>
              <Route path="/payment/:orderId" element={<PaymentSuccess />}></Route>
              {/* Akhil comments - NotFound route commented out */}
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
          </div>
          <Footer />
        </div>

        {/* Auth Modal - Opens only when explicitly triggered */}
        <AuthModal handleClose={handleCloseAuthModal} open={openAuthModal} />
      </ThemeProvider>

    </div>
  );
};

export default CustomerRoutes;

